import { safeJsonParse } from './safeJsonParse';

export const urlNavigate = (baseUrl = '/', toUrl = '') => {
    const page = safeJsonParse(localStorage.getItem('page'), {});
    const outlet = safeJsonParse(localStorage.getItem('outlet'), {});

    const brandName = (page['slug'] || '').toString().toLowerCase();
    const outletCode = (page['outletName'] || outlet['outletCode'] || '').toString().trim().toLowerCase();

    const url = `/${brandName}/${outletCode}`;
    const cleanBaseUrl = baseUrl.toString().startsWith('/') ? baseUrl.slice(1) : baseUrl;
    const cleanToUrl = toUrl.toString().startsWith('/') ? toUrl.slice(1) : toUrl;

    if (cleanToUrl !== '') {
        return `${url}/${cleanBaseUrl}/${cleanToUrl}`;
    }

    return `${url}/${cleanBaseUrl}`;
};
